import { render } from "./MarkStudentSectionAttendanceModal.vue?vue&type=template&id=68851855&scoped=true"
import script from "./MarkStudentSectionAttendanceModal.vue?vue&type=script&lang=js"
export * from "./MarkStudentSectionAttendanceModal.vue?vue&type=script&lang=js"

import "./MarkStudentSectionAttendanceModal.vue?vue&type=style&index=0&id=68851855&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68851855"]])

export default __exports__